module.exports = __webpack_public_path__ + "img/vimeo-logo.96e166c6.png";